<div class="modal-content">

    <div class="modal-body pb-5">
        <img src="assets/img/user-white.svg">
        <h3 class="mt-2">{{escritorio.ejecutivo}}</h3>
        <hr class="w-75 mx-auto">
        <h6>Atención remota con: {{turno.cliente}}</h6>
    </div>
    <div class="modal-footer">
        <div src="" id="llamadaJitsi" class="jitsi" style="width: 100%;" allow="camera;microphone"></div>
        <div class="row mx-auto">
            <div class="col-6">
                <div class="col-12 text-center">
                    <button type="button" class="btn-color" (click)="terminarAtencion(); api.dispose();">CERRAR Y FINALIZAR ATENCIÓN</button>
                </div>
            </div>
            <div class="col-6">
                <div class="col-12 text-center">
                    <button type="button" class="btn-color" (click)="closeModal(); api.dispose();">CERRAR</button>
                </div>
            </div>
        </div>
    </div>
</div>